import { createAction, createReducer } from '@reduxjs/toolkit'
import Cookies from 'universal-cookie';

//action creater
export const bugAdded = createAction("bugAdded")
// export function bugAdded(description){
//     return {
//         type:BUG_ADDED,
//         payload:{
//             description
//         }
//     }
// }
//arrow function syntex
export const bugRemoved = createAction("bugRemoved");
export const bugResolved = createAction("bugResolved");
// export const bugRemoved =  id => ({   
//     type:BUG_REMOVED,
//     payload:{
//         id
//     }    
// })

// export const bugResolved = id => ({   
//     type:BUG_RESOLVED,
//     payload:{
//         id
//     }    
// })

const stete = {
    token:null,    
    auth:null,
    userName:null,
    password:null,
    theme:null,
    bugs:[],
}


export const setToken = createAction("setToken")
export const setUserName = createAction("setUserName")
export const setPassword = createAction("setPassword")

export const loginSuccess = createAction("loginSuccess")
export const logoutSuccess = createAction("logoutSuccess") 
export const switchRole = createAction("switchRole")
export const setTheme = createAction("setTheme")
const cookies = new Cookies();



let lastId = 0;
export default createReducer(stete,{
    bugAdded:(state, action) =>{
        state.bugs.push({
            id:++lastId,
            description:action.payload.description,
            resolved:false
        })
    },

    setToken:(state, action) =>{
        state.token=action.payload.token
    },
    setUserName:(state, action) =>{
        state.userName=action.payload.userName
    },
    setPassword:(state, action) =>{
        state.password=action.payload.password
    },
    setTheme:(state, action) =>{
        state.theme=action.payload.theme
    },

    loginSuccess:(state, action) =>{
        state.auth=action.payload.auth
    },
    logoutSuccess:(state, action) =>{
        state.auth.loggedIn=false;
        state.auth.user=null;
        state.token=null
        state.userName=null
        state.password=null
        state.theme=null
    },

    switchRole:(state, action) =>{     
        state.auth.user.default_role_code=action.payload.role;
        state.auth.user.default_description=action.payload.description;        
    },

    [bugResolved.type]:(state, action)=>{
        const index = state.bugs.findIndex(bug => bug.id===action.payload.id);
        state.bugs[index].resolved=true;
    },

    bugRemoved:(state, action) => {
        return state.bugs.filter(bug => bug.id !== action.payload.id)
    }

})

